import React from 'react';

import { Button } from '@mui/material';

import FindReplaceIcon from '@mui/icons-material/FindReplace';
const FilterButton = ({ filterOnClick, modalState }) => {
  return (
    <Button
      size='small'
      onClick={() => filterOnClick()}
      startIcon={<FindReplaceIcon />}
      sx={{
        color: modalState === 'notSet' ? '#354775' : '#ff2222',
      }}
    >
      {modalState === 'notSet' ? 'Set Filter' : 'Clear/Change Filter'}
    </Button>
  );
};

export default FilterButton;
